var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFishbone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "217.24mm",
    height: "116.66mm",
    viewBox: "0 0 217.24 116.66",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.3616 4.0893)",
    fill: "#00c0ff",
    stroke: "#000",
    strokeWidth: 0.37118
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(90 65.425 105.85)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.333,
    y: 68.827,
    width: 39.629,
    height: 19.629,
    opacity: 0.996
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(90)",
    x: 49.198,
    y: -22.333,
    width: 39.629,
    height: 19.629,
    opacity: 0.996
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.333,
    y: 49.198,
    width: 39.629,
    height: 19.629,
    opacity: 0.996
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.4745 1.3363)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(27.47 46.301 -103.9)"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(-90)",
    x: -44.929,
    y: 71.962,
    width: 39.629,
    height: 19.629,
    opacity: 0.996
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.591,
    y: 5.2999,
    width: 39.629,
    height: 19.629,
    opacity: 0.996
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(27.47 -54.845 -79.181)"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(-90)",
    x: -44.929,
    y: 71.962,
    width: 39.629,
    height: 19.629,
    opacity: 0.996
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.591,
    y: 5.2999,
    width: 39.629,
    height: 19.629,
    opacity: 0.996
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 201.04 1.6036)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(27.47 46.301 -103.9)"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(-90)",
    x: -44.929,
    y: 71.962,
    width: 39.629,
    height: 19.629,
    opacity: 0.996
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.591,
    y: 5.2999,
    width: 39.629,
    height: 19.629,
    opacity: 0.996
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(27.47 -54.845 -79.181)"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(-90)",
    x: -44.929,
    y: 71.962,
    width: 39.629,
    height: 19.629,
    opacity: 0.996
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.591,
    y: 5.2999,
    width: 39.629,
    height: 19.629,
    opacity: 0.996
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFishbone);
export default __webpack_public_path__ + "static/media/fishbone.b90f68a722e5293a2049c69060535f3e.svg";
export { ForwardRef as ReactComponent };